__turbopack_context__.v({
  "hidden": "video-module-scss-module__ZJHFsa__hidden",
  "play": "video-module-scss-module__ZJHFsa__play",
  "player": "video-module-scss-module__ZJHFsa__player",
  "poster": "video-module-scss-module__ZJHFsa__poster",
  "responsive-image": "video-module-scss-module__ZJHFsa__responsive-image",
  "wrapper": "video-module-scss-module__ZJHFsa__wrapper",
});
